<template><section>
<div class="page">
  <div>
    <h2>Account Security Tips</h2>
    <p>
      Better secure your ToTok account and help prevent others from using your phone number in the future by following
      these tips:
    </p>
    <ul>
      <li>Never share a 6-digit ToTok SMS verification code with others, even if the other person appears to be someone
        you know or an organization you trust. ToTok does not ask you to share your verification code.
      </li>
      <li>Set a PIN lock to better secure your phone.</li>
    </ul>
    <p>We recommend you share this advice with friends and family to help secure their ToTok accounts.</p>
  </div>
</div>
 </section>
</template>

<script>
    export default {
        components: {},
        data() {
            return {};
        },
        computed: {},
        methods: {}
    }
</script>
